import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import style from './filter-bar.module.less';
import messages from './messages';

const ClearFilters = ({ clearFilters, className = '' }) => (
  <Button className={classnames(style['clear-filters-button'], className)} onClick={clearFilters} theme='danger-link'>
    <FontAwesomeIcon icon={faTimes} />
    <FormattedMessage {...messages.clearFilters} />
  </Button>
);

ClearFilters.propTypes = {
  clearFilters: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default ClearFilters;
